import { contractDate, contractTime } from "./planningDates";
import { CONTRACT_STATUSES } from "./contractStatus";

const examples = [
  ["Entreprise de démonstration", "Camille Martin", "Assistant administratif"],
  ["Résidence des Lilas (exemple)", "Alex Moreau", "Aide-soignant"],
  ["Clinique du Parc (exemple)", "Sarah Bernard", "Infirmière"],
  ["Logistique Horizon (exemple)", "Hugo Petit", "Préparateur de commandes"],
  ["Atelier du Centre (exemple)", "Emma Laurent", "Agent de production"],
  [
    "Résidence du Soleil (exemple)",
    "Lucas Robert",
    "Agent de service hospitalier",
  ],
  ["Services Ensemble (exemple)", "Léa Dubois", "Auxiliaire de vie"],
  ["Transport Azur (exemple)", "Adam Michel", "Manutentionnaire"],
  ["Bureau Nouvelle Rive (exemple)", "Chloé Simon", "Chargée d’accueil"],
  ["Maison des Jardins (exemple)", "Noah Roux", "Agent d’entretien"],
];
export function demoContracts(audience) {
  const contracts = examples.map(([company, name, qualification], index) => ({
    _id: `demo-contract-${audience}-${index + 1}`,
    isDemo: true,
    NumeroContrat: `EXEMPLE-${audience === "client" ? "CLIENT" : "INTERIM"}-${String(index + 1).padStart(3, "0")}`,
    RaisonSociale: company,
    NomPrenom: `${name} (exemple)`,
    Qualification: qualification,
    DateDebut: `202610${String(8 + index).padStart(2, "0")}`,
    DateFin: `202610${String(16 + index).padStart(2, "0")}`,
    statut: [
      CONTRACT_STATUSES.unsigned,
      CONTRACT_STATUSES.paper,
      CONTRACT_STATUSES.signed,
    ][index % 3],
  }));
  if (audience === "client") {
    const vacations = [
      [
        "Résidence des Lilas (exemple)",
        "Dourdan",
        "Rita Martin",
        "Infirmière",
        ["2026-10-21", "2026-10-23"],
      ],
      [
        "Clinique du Parc (exemple)",
        "Toulouse",
        "Sarah Bernard",
        "Aide-soignante",
        ["2026-10-12", "2026-10-14", "2026-10-16"],
      ],
      [
        "Résidence du Soleil (exemple)",
        "Brive",
        "Lucas Robert",
        "Agent de service hospitalier",
        ["2026-10-19"],
      ],
    ];
    contracts.push(
      ...vacations.map(
        ([company, city, name, qualification, dates], index) => ({
          _id: `demo-contract-client-vacation-${index + 1}`,
          isDemo: true,
          contractType: "vacation",
          NumeroContrat: `EXEMPLE-VACATION-${String(index + 1).padStart(3, "0")}`,
          RaisonSociale: company,
          AdresseVille: city,
          NomPrenom: `${name} (exemple)`,
          Qualification: qualification,
          dates,
          DateDebut: dates[0].replace(/-/g, ""),
          DateFin: dates[dates.length - 1].replace(/-/g, ""),
          HeureDebut: "0800",
          HeureFin: "1600",
          statut: [
            CONTRACT_STATUSES.unsigned,
            CONTRACT_STATUSES.signed,
            CONTRACT_STATUSES.paper,
          ][index],
        }),
      ),
    );
  }
  return contracts;
}

export async function demoContractPdf(contract) {
  const { jsPDF } = await import("jspdf");
  const pdf = new jsPDF();
  pdf.setTextColor(6, 72, 120);
  pdf.setFontSize(22);
  pdf.text("JM INTERIM", 20, 25);
  pdf.setFontSize(14);
  pdf.text("CONTRAT D’EXEMPLE", 20, 40);
  pdf.setTextColor(100);
  pdf.setFontSize(11);
  pdf.text(
    "Document fictif de demonstration - sans valeur contractuelle",
    20,
    52,
  );
  const lines = [
    `Numero : ${contract.NumeroContrat}`,
    `Registre : ${contract._id.includes("client") ? "Contrat client" : "Contrat interimaire"}`,
    `Entreprise : ${contract.RaisonSociale}`,
    `Interimaire : ${contract.NomPrenom}`,
    `Poste : ${contract.Qualification}`,
    `Periode : du ${contractDate(contract.DateDebut)?.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" })} au ${contractDate(contract.DateFin)?.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" })}`,
    `Horaires : ${contractTime(contract.HeureDebut) || "09:00"} - ${contractTime(contract.HeureFin) || "17:00"}`,
    `Statut : ${contract.statut}`,
  ];
  pdf.setTextColor(30);
  lines.forEach((line, index) => pdf.text(line, 20, 75 + index * 12));
  return pdf.output("blob");
}
